import CommonConfigDao from "./CommonConfigDao";
import { CarBrand, CarModel, Country, VehicleType } from "../model";
import { MobilityApiInterface, CountriesApiInterface } from "../swagger";

export class SwaggerCommonConfigDao implements CommonConfigDao {
  private readonly _mobilitySwaggerClient: MobilityApiInterface;
  private readonly _countriesSwaggerClient: CountriesApiInterface;

  public constructor(
    mobilitySwaggerClient: MobilityApiInterface,
    countriesSwaggerClient: CountriesApiInterface
  ) {
    this._mobilitySwaggerClient = mobilitySwaggerClient;
    this._countriesSwaggerClient = countriesSwaggerClient;
  }

  public async getCarBrands(): Promise<CarBrand[]> {
    const res = await this._mobilitySwaggerClient.getCarBrand();
    const dbCarBrands = res.data.rows;

    if (dbCarBrands === undefined) return [];

    return dbCarBrands
      .map(dbCarBrand => {
        const id = dbCarBrand.id;
        const label = (dbCarBrand.key[1] as unknown) as string;
        const position = (dbCarBrand.key[0] as unknown) as number;

        if (id === undefined || label === undefined || position === undefined) {
          return undefined;
        }

        return {
          id: id,
          label: label,
          value: label.toLowerCase(),
          position: position
        };
      })
      .filter(item => item !== undefined) as CarBrand[];
  }

  public async getCarModels(): Promise<CarModel[]> {
    const couchDbRes = (await this._mobilitySwaggerClient.getModelCar()).data
      .rows;
    if (couchDbRes === undefined) return [];

    return couchDbRes
      .map(elt => {
        if (
          elt.id === undefined ||
          elt.key === undefined ||
          elt.value === undefined
        )
          return undefined;

        return {
          id: elt.id,
          label: elt.key,
          value: elt.key.toLowerCase(),
          carBrand: {
            id: elt.id,
            label: elt.value,
            value: elt.value.toLowerCase()
          }
        };
      })
      .filter(item => item !== undefined) as CarModel[];
  }

  public async getCountries(): Promise<Country[]> {
    const couchDbRes = (await this._countriesSwaggerClient.getCountriesAlpha2())
      .data.rows;
    if (couchDbRes === undefined) return [];

    return couchDbRes
      .map(elt => {
        if (
          elt.id === undefined ||
          elt.key === undefined ||
          elt.value === undefined
        )
          return undefined;

        return {
          id: elt.id,
          label: elt.value,
          value: elt.key
        };
      })
      .filter(item => item !== undefined) as Country[];
  }

  public async getVehicleTypes(): Promise<VehicleType[]> {
    const couchDbRes = (await this._mobilitySwaggerClient.getVehicleType()).data
      .rows;
    if (couchDbRes === undefined) return [];

    return couchDbRes
      .map(elt => {
        if (
          elt.id === undefined ||
          elt.key === undefined ||
          elt.value === undefined
        )
          return undefined;

        return {
          id: elt.id,
          label: elt.key,
          value: elt.value
        };
      })
      .filter(item => item !== undefined) as VehicleType[];
  }
}

export default SwaggerCommonConfigDao;
